var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileLike24X24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9461 6.21524C18.561 5.83002 18.1034 5.5244 17.5996 5.31587C17.0958 5.10734 16.5558 5 16.0104 5C15.465 5 14.9249 5.10734 14.4211 5.31587C13.9174 5.5244 13.4598 5.83002 13.0746 6.21524L11.9995 7.28778L10.9244 6.21524C10.1456 5.43826 9.08928 5.00176 7.98786 5.00176C6.88644 5.00176 5.83014 5.43826 5.05132 6.21524C4.2725 6.99221 3.83496 8.04602 3.83496 9.14482C3.83496 10.2436 4.2725 11.2974 5.05132 12.0744L6.12641 13.147L12.0041 19L17.8757 13.1424L18.9508 12.0698C19.3361 11.6853 19.6417 11.2287 19.8501 10.7263C20.0584 10.2238 20.1655 9.68533 20.165 9.14157C20.1646 8.59782 20.0567 8.05948 19.8476 7.55736C19.6384 7.05523 19.3321 6.59916 18.9461 6.21524Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLike24X24);
export default __webpack_public_path__ + "static/media/mobile-like-24x24.836dbbdf0dc590ebf353e7847bcbb5fd.svg";
export { ForwardRef as ReactComponent };